import React from 'react';
import { cn } from '@/lib/utils';
import { HeatLevel } from '../hooks/usePostHeatLevel';

interface PostHeatBadgeProps {
  heatLevel: HeatLevel;
  className?: string;
}

export function PostHeatBadge({ heatLevel, className }: PostHeatBadgeProps) {
  if (heatLevel.level === 0) return null;
  
  return (
    <div className={cn(
      "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold",
      // Level 1: Warming - subtle amber
      heatLevel.level === 1 && "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
      // Level 2: Hot - orange
      heatLevel.level === 2 && "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
      // Level 3: Fire - red with animation
      heatLevel.level === 3 && "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 animate-pulse",
      // Level 4: Viral - purple/rainbow with animation
      heatLevel.level === 4 && "bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white animate-pulse",
      className
    )}>
      <span>{heatLevel.emoji}</span>
      <span>{heatLevel.label}</span>
      {heatLevel.hasCombo && heatLevel.level < 4 && (
        <span className="ml-0.5 text-[10px] opacity-75">+Combo</span>
      )}
    </div>
  );
}
